import { commonConstants } from "@/actions/constants/commonConstants";
import { enquiryConstants } from "@/actions/constants/enquiryConstant";
import { enquiryService } from "@/services/enquiryService";
import { call, put } from "redux-saga/effects";

function* createEnquirySaga(action: any) {
    try {
        const response = yield call(enquiryService.createEnquiryService, action.payload);
        if (response.success) {
            yield put({ type: enquiryConstants.createEnquirySuccess, payload: response.resultObject });
            yield put({ type: commonConstants.showSuccessMessage, payload: response.message });
        } else {
            yield put({ type: enquiryConstants.createEnquiryFailure, payload: response.data });
            yield put({ type: commonConstants.showErrorMessage, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: enquiryConstants.createEnquiryFailure, payload: error });
        yield put({ type: commonConstants.showErrorMessage, payload: error });
    }
}
function* listEnquirySaga(action: any) {
    try {
        const response = yield call(enquiryService.listEnquiryService, action.payload);
        if (response.success) {
            yield put({ type: enquiryConstants.listEnquirySuccess, payload: response.resultObject });
        } else {
            yield put({ type: enquiryConstants.listEnquiryFailure, payload: response.data });
            yield put({ type: commonConstants.showErrorMessage, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: enquiryConstants.listEnquiryFailure, payload: error });
         yield put({ type: commonConstants.showErrorMessage, payload: error });
    }
}
function* deleteEnquirySaga(action: any) {
    try {
        const response = yield call(enquiryService.deleteEnquiryService, action.payload);
        if (response.success) {
            yield put({ type: enquiryConstants.deleteEnquirySuccess, payload: response.resultObject });
            yield put({ type: commonConstants.showSuccessMessage, payload: response.message });
        } else {
            yield put({ type: enquiryConstants.deleteEnquiryFailure, payload: response.data });
            yield put({ type: commonConstants.showErrorMessage, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: enquiryConstants.deleteEnquiryFailure, payload: error });
         yield put({ type: commonConstants.showErrorMessage, payload: error });
    }
}


function* viewEnquirySaga(action: any) {
    try {
        const response = yield call(enquiryService.viewEnquiryService, action.payload);
        if (response.success) {
            yield put({ type: enquiryConstants.viewEnquirySuccess, payload: response.resultObject });
        } else {
            yield put({ type: enquiryConstants.viewEnquiryFailure, payload: response.data });
            yield put({ type: commonConstants.showErrorMessage, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: enquiryConstants.viewEnquiryFailure, payload: error });
         yield put({ type: commonConstants.showErrorMessage, payload: error });
    }
}
function* updateEnquirySaga(action: any) {
    try {
        const response = yield call(enquiryService.updateEnquiryService, action.payload);
        if (response.success) {
            yield put({ type: enquiryConstants.updateEnquirySuccess, payload: response.resultObject });
            yield put({ type: commonConstants.showSuccessMessage, payload: response.message });
        } else {
            yield put({ type: enquiryConstants.updateEnquiryFailure, payload: response.data });
            yield put({ type: commonConstants.showErrorMessage, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: enquiryConstants.updateEnquiryFailure, payload: error });
         yield put({ type: commonConstants.showErrorMessage, payload: error });
    }
}

export const enquirySaga = {
    createEnquirySaga,
    listEnquirySaga,
    deleteEnquirySaga,
    viewEnquirySaga,
    updateEnquirySaga
}